module.exports = __webpack_public_path__ + "static/img/icons8-open_envelope_stamp.743573a5.svg";